import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListProductGridCard";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListProductGridCard";

export default WidgetModule;
